import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Cv from "../img/MyCv.jpg";
import { Mobile } from "../Response";
const ShowCv = ({ Show_Cv }) => {
  return (
    Show_Cv && (
      <Container>
        <CvCon>
          <ImgCon src={Cv} />
        </CvCon>
      </Container>
    )
  );
};
export default ShowCv;
const Container = styled.div`
  overflow: hidden;
  width: 56%;
  height: 90%;

  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 8;
  ${Mobile({ width: "100vw", height: "auto" })}
`;

const CvCon = styled.div`
  width: 36%;
  height: 90%;
  z-index: 8;
  position: fixed;
  top: 0;

  // backdrop-filter: blur(10px);
  // margin-left: 1%;
  margin-top: 4%;
  ${Mobile({ width: "95%", height: "auto", marginTop: "8%" })}
`;
const ImgCon = styled.img`
  width: 100%;
  height: 100%;
`;
